import React from 'react';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { IconButton, Tooltip } from '@mui/material';
import Icons from '../../../components/icons';
import { Gender, Status, UserRole } from '../../../enums';
import { AdminAccess, SchoolOfficeUser } from '../../../types/schoolCollection';

type EditHandler = (user: SchoolOfficeUser) => void;

const renderActionCell =
  (onEdit?: EditHandler) =>
  (params: GridRenderCellParams<any, SchoolOfficeUser>) =>
    React.createElement(Tooltip, {
      title: 'View / Edit',
      children: React.createElement(
        'span',
        null,
        React.createElement(
          IconButton,
          {
            size: 'small',
            disabled: !onEdit,
            onClick: () => onEdit && onEdit(params.row as SchoolOfficeUser)
          },
          React.createElement(Icons.EditBlackOutlined, null)
        )
      )
    });

const schoolOfficeUserColumns = (onEdit?: EditHandler): GridColDef[] => {
  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'email', headerName: 'Email', flex: 1 },
    { field: 'gender', headerName: 'Gender', flex: 0.7 },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.7,
      valueFormatter: (params) => {
        if (params === Status.INACTIVE) {
          return 'INACTIVE';
        }
        return params;
      }
    }
  ];
  if (onEdit) {
    columns.push({
      field: 'action',
      headerName: 'Action',
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: renderActionCell(onEdit)
    });
  }
  return columns;
};

const initialState = {
  name: '',
  email: '',
  gender: '' as '' | Gender,
  role: UserRole.SCHOOL_OFFICE,
  adminAccess: {
    ether: true,
    easypay: false,
    busTracking: false
  }
};

const DEFAULT_ACCESS: AdminAccess = {
  ether: true,
  easypay: false,
  busTracking: false
};

export { schoolOfficeUserColumns, EditHandler, initialState, DEFAULT_ACCESS };
